import { lazy } from 'react'

export const UserRoutes = [
    {
        path: '/login',
        component: lazy(() => import('../views/auth/Login')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        }
    },
    {
        path: '/register',
        component: lazy(() => import('../views/auth/Register')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        }
    },
    {
        path: '/forgot-password',
        component: lazy(() => import('../views/auth/ForgotPassword')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        }
    },
    {
        path: '/reset-password/:email',
        component: lazy(() => import('../views/auth/ResetPassword')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        }
    },
    {
        path: '/2fa/:email/',
        component: lazy(() => import('../views/auth/TwoFactorAuth')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        }
    },
    {
        path: '/user/account-settings',
        component: lazy(() => import('../views/account-settings')),
        meta: {
            general: true
        }
    },
    {
        path: '/user/list',
        component: lazy(() => import('../views/user-list')),
        meta: {
            action: 'call',
            resource: 'USR_VIEW_USER_LIST|USR_MANAGE_USER'
        }
    },
    {
        path: '/group/list',
        component: lazy(() => import('../views/group-list')),
        meta: {
            action: 'call',
            resource: 'USR_VIEW_GROUP_LIST|USR_MANAGE_GROUP'
        }
    },
    {
        path: '/group/:groupId/users',
        component: lazy(() => import('../views/users-group-list')),
        meta: {
            action: 'call',
            resource: 'USR_MANAGE_GROUP'
        }
    },
    {
        path: '/user/role',
        component: lazy(() => import('../views/role-list')),
        meta: {
            action: 'call',
            resource: 'USR_MANAGE_ROLE'
        }
    }
]

